module.exports = __webpack_public_path__ + "img/thierry-circle-transparent.9f959de4.png";